<app-address-latitude (isErrorEvent)="onError($event)"
    (addressEvent)="onAddress($event)"
    (latitudeEvent)="onLatitude($event)"></app-address-latitude>
<div *ngIf="!isError">
    <app-heb-datetime [place]="address"></app-heb-datetime>
    <app-ruling-planets></app-ruling-planets>
</div>

